import React from "react";

export default props => {
    return (
        <div style={props.style}>
            <span>Copyright © 2020 - Sankhya Gestão de Negócios. Todos os direitos reservados.</span>
        </div>
    )
}
